import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "../css/Page.module.css";

const importAll = (r) => r.keys().map(r);
const showImages = importAll(
  require.context("../assets/images/shows", false, /\.(png|jpe?g|webp)$/)
);

function Shows() {
  return (
    <div className={`${styles.container} ${styles.showsContainer}`}>
      <Header />
      <div className={`${styles.content} ${styles.showsContent}`}>
        <h1 className={styles.title}>Shows</h1>
        <p className={styles.text}>
          Explore our portfolio of spectacular shows and events. From intimate gatherings to grand celebrations, we create unforgettable experiences.
        </p>
        <div className={styles.showsGrid}>
          {showImages.map((imageSrc, index) => (
            <div key={index} className={styles.showItem}>
              <img src={imageSrc} alt={`Serenade show ${index + 1}`} className={styles.showImage} />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Shows;

